import { action , observable, computed } from "mobx";
import { PanelAddon } from "./PanelAddon";

import contextStore from './ContextStore'
import { ChromeState } from "meet-addons-sdk";

export class PanelStore {

    @observable
    public addons: PanelAddon[] = [];

    @action
    public getActiveAddon = () => {
        return this.addons.find(p => p.active);
    }

    @action
    public register = (addon: PanelAddon) => {
        if (!this.addons.find(p => p.addonIdentifier === addon.addonIdentifier)) {
            
            if (this.addons.length === 0 && contextStore.chromeState !== ChromeState.FULLSCREEN) {
                addon.active = true;
            }
            
            this.addons.push(addon);
        }
    }

    @action
    public markAsActive = (addonIdentifier: string) => {
        const addon = this.addons.find(p => p.addonIdentifier === addonIdentifier);
        if (addon) {
            if (addon.exclusive) {
                this.addons.forEach(addon => addon.active = false);
            }

            addon.active = true;
        }
    }

    
    @action
    public toggle = (addonIdentifier: string) => {
        const clone = [...this.addons];
        const addon = clone.find(p => p.addonIdentifier === addonIdentifier);


        if (addon) {
            const currentValue = addon.active;

            if (addon.exclusive && !addon.active) {
                clone.forEach(a => a.active = false);
            }
            addon.active = !currentValue;
        }

        this.addons = clone;
    }
    
    @action
    public markAsInactive = (addonIdentifier: string) => {
        const addon = this.addons.find(p => p.addonIdentifier === addonIdentifier);
        if (addon) {
            addon.active = false;
        }
    }

    @action
    public updateRuntimeContext = (addonIdentifier: string, text: string)  => {

        var addonIndex = this.addons.findIndex(p => p.addonIdentifier === addonIdentifier);
        if (addonIndex > -1) {
            const addon = {...this.addons[addonIndex]};
            addon.context = text;
            this.addons.splice(addonIndex, 1, addon);
        }
    }

    @action 
    public unselectAll = () => {
        this.addons.forEach(addon => addon.active = false);
    }

    @computed
    public get activeAddons() {
        return this.addons.filter(a => a.active);
    }
}

export default new PanelStore();
